module.exports = __webpack_public_path__ + "media/images/card_amex-f2a2d49c086d1519139d56b2f0a72ff3.jpg";